var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7173 22.4774C17.6814 20.5134 17.0432 17.4733 15.232 14.785L21.114 8.90319C22.6498 9.88243 24.1566 10.2677 25 9.42388L16.5762 1C15.7324 1.84378 16.1181 3.35008 17.0969 4.88586L11.215 10.7676C8.52657 8.95658 5.48638 8.31836 3.52227 10.2824L8.39988 15.1599L4.36847 19.1911L1 25L6.80867 21.6316L10.8401 17.6004L15.7173 22.4774Z",
    fill: "none",
    className: "fill-selector",
    stroke: "#B8B8B8",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.b8236cab5887181122e78e5afb4525ef.svg";
export { ForwardRef as ReactComponent };